import { createFileRoute } from "@tanstack/react-router"

import { TruthCardsPanel } from "@/pages/TruthCardsPanel"

export const Route = createFileRoute("/reference/truth-cards")({
  // `?asset=CIV.ONC.01` opens straight to one card. A fact-check finding names its asset, so this
  // is the link My Cleanup needs to hand someone the card their finding is measured against —
  // declared here or the router strips it (same reason /operations/corpus declares `docId`).
  validateSearch: (search: Record<string, unknown>): { readonly asset?: string } => ({
    asset: typeof search.asset === "string" && search.asset !== "" ? search.asset : undefined,
  }),
  component: TruthCardsPanel,
})
